// ── premierePlan ──────────────────────────────────────────────────────────────
// "Ready by the premiere." NextEp knows two things nobody else puts together: where
// you are in a show and when its next season starts. If you're behind and a premiere
// is on the calendar, that's a pace, not a countdown: "3 episodes a week and you're
// caught up for S3 on Nov 20." Pure; tested in premierePlan.test.js.
//
//   seasons  TMDB show.seasons: [{ season_number, episode_count }]
//   upcoming TMDB show.next_episode_to_air: { season_number, episode_number, air_date }
//   position { season, episode } = the NEXT episode to watch (progress model)
//   today    'YYYY-MM-DD'
// Returns null unless the next thing to air is a season PREMIERE, it is at least two
// days out, and there are aired episodes left before it. Otherwise:
//   { remaining, days, weeks, perWeek, perDay, season, airDate }
const DAY = 86400000
const dayOf = (d) => { const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d || '')); return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) : null }

export function remainingBefore(seasons, position, upToSeason) {
  if (!position?.season) return 0
  let n = 0
  for (const s of seasons || []) {
    const sn = s.season_number
    if (sn < position.season || sn >= upToSeason || sn === 0) continue
    const count = s.episode_count || 0
    n += sn === position.season ? Math.max(0, count - (position.episode - 1)) : count
  }
  return n
}

export function premierePlan({ seasons, upcoming, position, today }) {
  if (!upcoming?.air_date || upcoming.episode_number !== 1 || !position?.season) return null
  if (position.season >= upcoming.season_number) return null
  const a = dayOf(upcoming.air_date), t = dayOf(today)
  if (a == null || t == null) return null
  const days = Math.round((a - t) / DAY)
  if (days < 2) return null
  const remaining = remainingBefore(seasons, position, upcoming.season_number)
  if (remaining < 1) return null
  const weeks = Math.max(1, Math.ceil(days / 7))
  const perWeek = Math.ceil(remaining / weeks)
  const perDay = Math.ceil(remaining / days)
  return { remaining, days, weeks, perWeek, perDay, season: upcoming.season_number, airDate: upcoming.air_date }
}

// The one line under Next up. Weeks when there's room, days when it's close.
export function premiereLine(plan) {
  if (!plan) return ''
  const left = `${plan.remaining} episode${plan.remaining === 1 ? '' : 's'} left`
  if (plan.days >= 14) return `${left} · ${plan.perWeek} a week and you’re ready for S${plan.season}`
  if (plan.perDay <= 1) return `${left} · one a day and you’re ready for S${plan.season}`
  return `${left} · ${plan.perDay} a day and you’re ready for S${plan.season}`
}
